interface WalletSidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const WalletSidebar = ({ activeTab, setActiveTab }: WalletSidebarProps) => {
  return (
    <div className="md:w-64 bg-[#1438871A] p-4">
      <nav className="gap-2 flex items-start md:block">
        <button
          onClick={() => setActiveTab("wallet-pin")}
          className={`w-full text-left md:px-4 md:py-3 px-1 py-1 whitespace-nowrap rounded-lg text-sm font-medium transition-colors ${
            activeTab === "wallet-pin"
              ? "bg-[#B4C0D8] text-fleetblue"
              : "text-[#00032AB2] hover:bg-gray-100"
          }`}
        >
          Wallet PIN
        </button>
        <button
          onClick={() => setActiveTab("payout-accounts")}
          className={`w-full text-left md:px-4 md:py-3 px-1 py-1 whitespace-nowrap rounded-lg text-sm font-medium transition-colors ${
            activeTab === "payout-accounts"
              ? "bg-[#B4C0D8] text-fleetblue"
              : "text-[#00032AB2] hover:bg-gray-100"
          }`}
        >
          Manage Payout Accounts
        </button>
        <button
          onClick={() => setActiveTab("alert-preferences")}
          className={`w-full text-left md:px-4 md:py-3 px-1 py-1 whitespace-nowrap rounded-lg text-sm font-medium transition-colors ${
            activeTab === "alert-preferences"
              ? "bg-[#B4C0D8] text-fleetblue"
              : "text-[#00032AB2] hover:bg-gray-100"
          }`}
        >
          Alert Preferences
        </button>
        {/* <button
          onClick={() => setActiveTab("activity-log")}
          className={`w-full text-left md:px-4 md:py-3 px-1 whitespace-nowrap rounded-lg text-sm font-medium transition-colors ${
            activeTab === "activity-log"
              ? "bg-[#B4C0D8] text-fleetblue"
              : "text-[#00032AB2] hover:bg-gray-100"
          }`}
        >
          Wallet Activity Log
        </button> */}
      </nav>
    </div>
  );
};

export default WalletSidebar;
